import StorageService from '@/services/storage.service'
import storageKeys from '@/constans/storageKeys'
import { defaultFilters } from '@/models/Panels/helpers'
import panelsRepository from '@/repository/generatedRepository/panelsRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import panelsImageRepository from "@/repository/generatedRepository/panelsImageRepository";

const state = {
  list: [],
  listSearch: [],
  filters: StorageService.get(storageKeys.PANELS_FILTERS) || { ...defaultFilters },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  listSearch: state => state.listSearch,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.PANELS_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await panelsRepository.adminBlocks(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async searchPanels(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })
    const view = appliedFilters.images.type.value
    const { data } = await panelsRepository.adminBlocks(preparedFilters)
    context.commit('setListSearch', { data, view })
    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await panelsRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return panelsRepository.post(payload)
  },
  createImage(context, payload) {
    return panelsImageRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return panelsRepository.put(id, data)
  },
  updateImage(context, payload) {
    const { id, ...data } = payload
    return panelsImageRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return panelsRepository.delete(payload)
  },
  deleteImage(context, payload) {
    return panelsImageRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.PANELS_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.PANELS_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setListSearch(state, { data, view }) {
    data.items = data.items.map(element => {
      element.toggle = element.images.findIndex(image =>
        image.type === view && image.color === 'blue'
      )
      if (element.toggle === -1) element.toggle = element.images.findIndex(image =>
        image.type === view && image.color === 'gray'
      )
      if (element.toggle === -1) element.toggle = element.images.findIndex(image =>
        image.type === view && image.color === 'white'
      )
      return element
    })
    state.listSearch = [...data.items]
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
